import React from "react";
import { useSearchParams } from "react-router-dom";
import { BookOpen } from "lucide-react";
import WikiPanel from "@/components/WikiPanel";
import { Seitenkopf } from "@/hilfe/Seitenkopf";

export default function Wiki() {
    const [searchParams] = useSearchParams();
    const highlightEntry = searchParams.get("entry") || null;
    return (
        <div className="px-6 md:px-10 py-8 space-y-6">
            <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-md bg-slate-900 text-white grid place-items-center">
                    <BookOpen size={18} />
                </div>
                <div>
                    <div className="text-[11px] uppercase tracking-[0.2em] text-gray-500 mb-1">Wissen · App-weit</div>
                    <h1 className="font-heading text-3xl font-bold text-slate-900" data-testid="wiki-title">Wiki</h1>
                    <p className="text-sm text-gray-500 mt-1 max-w-2xl">
                        Halte generelle Abläufe, Kontaktlisten, Prozessbeschreibungen und Best Practices fest, die für die gesamte Verwaltung gelten.
                        Klick auf »Diktieren« – die KI transkribiert und strukturiert deine Sprachnotiz automatisch.
                    </p>
                    <Seitenkopf id="seite.wiki" />
                </div>
            </div>
            <WikiPanel scope="global" highlightEntry={highlightEntry} />
        </div>
    );
}
